import * as enums from '@/config/enum';

export function getPublicOption(optionKey) {
  return optionKey.split('.').reduce((prev, cur) => prev[cur], enums);
}

export function getPublicItem(optionKey, value) {
  return getPublicOption(optionKey).find(v => v.value === value);
}
